import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useUser } from "../Contexts/UserContext";
import GetDate from "../components/GetDate";
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Card,
  CardContent,
} from "@mui/material";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";

const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

const EventCard = styled(Card)(({ theme }) => ({
  width: "100%",
  height: "80px", // Fixed height for the EventCard
  overflow: "hidden",
  transition: "transform 0.3s ease",
  cursor: "pointer",
  position: "relative", // Ensure relative positioning for absolute icon
  "&:hover": {
    transform: "translateX(-10px)", // Shift left by 10px on hover
  },
  backgroundColor: theme.palette.background.paper,
}));

const UpcomingEvents = () => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const { user } = useUser();
  const date = GetDate();

  useEffect(() => {
    const getData = async () => {
      const response = await fetch(
        `${API_URL}/facility/get-events/1/${user.CompCode}/${user.ClientId}/NA/NA/${date}/${date}`
      ).then((res) => res.json());
      if (response.success) {
        console.log(response.data);
        filterData(response.data);
      } else {
        alert("Failed to load Upcoming events :(");
      }
    };
    getData();
  }, [user, date]);

  const filterData = (arr) => {
    const currentDate = new Date();
    const cDate = currentDate.toISOString().split("T")[0];
    let filteredArr = arr.filter((ele) => {
      const date1 = new Date(ele.EventStartDate).toISOString().split("T")[0];
      return cDate <= date1;
    });

    let newArr = filteredArr.slice(0, 2).map((ele) => {
      // Limit to maximum 3 events
      const parts = ele.EventStartDate.split("-");
      let month = parts[1];
      const monthNumber = parseInt(month, 10);
      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      month = monthNames[monthNumber - 1];

      const [year, mon, day] = ele.EventStartDate.split("-");
      return {
        id: ele.EventId, // Adding id to uniquely identify each event
        title: ele.EventName,
        month,
        monthNumber,
        date: day,
        start: ele.EventStartDate.slice(0, 10),
        end: ele.EventEndDate.slice(0, 10),
      };
    });

    setEvents(newArr);
  };

  const removeEvent = (id) => {
    const updatedEvents = events.filter((event) => event.id !== id);
    setEvents(updatedEvents);
  };

  const getColor = (index) => {
    const colors = [
      "#FFCDD2",
      "#F8BBD0",
      "#E1BEE7",
      "#D1C4E9",
      "#C5CAE9",
      "#BBDEFB",
      "#B3E5FC",
      "#B2EBF2",
      "#B2DFDB",
      "#C8E6C9",
      "#DCEDC8",
      "#F0F4C3",
      "#FFECB3",
      "#FFE0B2",
      "#FFCCBC",
      "#D7CCC8",
      "#F5F5F5",
      "#CFD8DC",
    ];
    return colors[index % colors.length];
  };

  return (
    <Box
      sx={{
        height: "160px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Grid
        container
        spacing={0}
        sx={{
          flexGrow: 1,
        }}
      >
        {events.length === 0 && (
          <Grid item xs={12} sm={6} md={12} key={0} padding={0}>
            <EventCard
              sx={{ backgroundColor: getColor(0) }}
              onClick={() => navigate(`/events`)}
            >
              <CardContent
                sx={{
                  padding: "5px 10px",
                  position: "relative",
                }}
              >
                <Typography variant="subtitle2" color="textSecondary">
                  No Events Available
                </Typography>
              </CardContent>
            </EventCard>
          </Grid>
        )}
        {events.map((event, index) => (
          <Grid item xs={12} sm={6} md={12} key={index} padding={0}>
            <EventCard
              sx={{ backgroundColor: getColor(index) }}
              onClick={() => navigate(`/events`)}
            >
              <CardContent sx={{ padding: "5px 10px", position: "relative" }}>
                <Typography variant="subtitle2" color="textSecondary">
                  {event.date} {event.month}
                </Typography>
                <Typography variant="body1" noWrap>
                  {event.title}
                </Typography>
                <IconButton
                  aria-label="delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    console.log(event);
                    removeEvent(event.id);
                  }}
                  sx={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </CardContent>
            </EventCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default UpcomingEvents;
